var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-big-dl';
                    var viewUrl = 'sprite.svg#view-icon-big-dl';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 40 40',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };